module.exports = __webpack_public_path__ + "static/media/home_produtos1.d88b909a.jpg";